declare const thiefcu3Trace: boolean;
// any file can define this global variable to enable tracing (even if false)
// or I can hardcode it myself:
// const thiefcu3Trace = true;

// warning: thiefcu3.ts does not behave exactly the same as the old js
// in the old js, spPick with xrst verb is not counted as a pick itself
// to align with spLoot, it is now counted
// to suppress counting the xrst record as a pick, must add nop verb
// <span class=spPick xrst=chkpid nop=yes></span>
// nop was not supported in the original js
// this change is required in m17,
// which now merges xrst with a regular pick

declare function suppAux1Test(attr: string): boolean;
declare function suppAux1Str(attr: string): string;
declare function suppAux2Test(attr: string): boolean;
declare function suppAux2Str(attr: string): string;

(() => {

  let doTrace = false;
  let suppAux: number;
  let seDiff: HTMLSelectElement;
  let seVer: HTMLSelectElement;

  type typeCum = number[];

  function fixAll(iDiff: number, iVer: number) {
    // recompute cum for diff level iDiff=0/1/2
    // recompute cum for version=0/1 (TDP/TG)

    function fixSupp(cur: HTMLSpanElement) {
      // returns true if li is not applicable to current diff/ver
      const curOnly = cur.getAttribute('only');
      const curVer = cur.getAttribute('ver');
      return ((curOnly) ? (curOnly.indexOf(sDiff) === -1) : false)
        || ((curVer) ? (curVer !== sVer) : false)
        || (suppAux > 0 && cur.getAttribute('suppAux1') && suppAux1Test(cur.getAttribute('suppAux1')))
        || (suppAux > 1 && cur.getAttribute('suppAux2') && suppAux2Test(cur.getAttribute('suppAux2')));
    }

    function fixSuppStr(cur: HTMLSpanElement) {
      let only3 = cur.getAttribute('only');
      let desc = '';
      if (only3) {
        if (only3.length === 2) only3 = only3.substr(0, 1) + '/' + only3.substr(1, 1); // insert separator
        desc = `, diff ${only3} only`;
      }
      const curVer = cur.getAttribute('ver');
      if (curVer) {
        desc += `, ${curVer} only`;
      }
      if (suppAux > 0 && cur.getAttribute('suppAux1')) desc += ', ' + suppAux1Str(cur.getAttribute('suppAux1'));
      if (suppAux > 1 && cur.getAttribute('suppAux2')) desc += ', ' + suppAux2Str(cur.getAttribute('suppAux2'));
      return desc;
    }

    function fixLootEntry(curCum: HTMLSpanElement, running: typeCum) {
      let oii = curCum.getAttribute('originalInnerText');
      if (!oii) {
        curCum.setAttribute('originalInnerText', oii = curCum.innerText);
      }
      const liis = oii.split(';'); // split into the three types
      // .map() is neater, but will need yet another polyfill
      const v = [+liis[0], +liis[1], +liis[2]];
      const mi = +curCum.getAttribute('copies');

      if (fixSupp(curCum)) {
        if (mi) {
          curCum.innerText = mi.toString() + '*' + fixLootFormat2(v, mi * (v[0] + v[1] + v[2])) + fixSuppStr(curCum);
        } else {
          curCum.innerText = fixLootFormat2(v, v[0] + v[1] + v[2]) + fixSuppStr(curCum);
        }
      } else {
        if (mi) {
          for (let i = 0; i < 3; i++) running[i] += v[i] * mi;
          curCum.innerText = '+' + mi.toString() + '*{' + oii + '}, total ' + fixLootFormat(running) + fixSuppStr(curCum);
        } else {
          for (let i = 0; i < 3; i++) running[i] += v[i];
          curCum.innerText = '+{' + oii + '}, total ' + fixLootFormat(running) + fixSuppStr(curCum);
        }
      }
    }

    function fixLootFormat(v: typeCum): string {
      // formats the loot array into "(x;y;z)=l"
      return fixLootFormat2(v, v[0] + v[1] + v[2]);
    }

    function fixLootFormat2(v: typeCum, vall: number): string {
      // formats the loot array into "(x;y;z) or l"
      // fixLookFormat, add v to get vall, I allow caller to specify
      return `{${v[0]};${v[1]};${v[2]}} or ${vall}`;
    }

    // running is an array, so passed by reference and we can update it
    function fixPickEntry(curCum: HTMLSpanElement, running: typeCum) {
      let oii = curCum.getAttribute('originalInnerText');
      if (!oii) {
        curCum.setAttribute('originalInnerText', oii = curCum.innerText);
      }
      const mi = +curCum.getAttribute('copies');

      if (fixSupp(curCum)) {
        curCum.innerText = `${oii} (${mi ? `${mi} picks` : 'one pick'}${fixSuppStr(curCum)})`;
      } else {
        let pick = running[0];
        if (mi) {
          let liit = oii + ' (pick';
          for (let j = 1; j < mi; j++) liit += (` #${++pick},`); // loop mi-1 times
          curCum.innerText = `${liit} #${++pick}${fixSuppStr(curCum)})`;
        } else {
          curCum.innerText = `${oii} (pick #${++pick}${fixSuppStr(curCum)})`;
        }
        running[0] = pick; // caller's array is updated
      }
    }

    function formatPickTotal(pick: typeCum): string {
      return pick[0] ? (pick[0] === 1 ? 'one pick' : `${pick[0]} picks`) : 'no pickpockets';
    }

    function fixCumAll(
      sCumType: string
      , sCumClass: string
      , initialCum: typeCum
      , fixCumEntry: (cur: HTMLSpanElement, running: typeCum) => void
      , formatCumTotal: (v: typeCum) => string
    ) {

      function trace(...arg: Array<string|number>) {
        if (doTrace) console.log(`${sCumType}:`, ...arg);
      }

      function warn(...arg: Array<string|number>) {
        console.log(`**** ${sCumType}:`, ...arg);
      }

      // stringify a typeCum
      function dispCum(c: typeCum): string {
        return c.join();
      }

      // main body of fixCumAll()
      const arrCum = document.getElementsByClassName(sCumClass) as HTMLCollectionOf<HTMLSpanElement>;
      const maxSeqCum = arrCum.length;
      if (maxSeqCum === 0) return;
      const arrHandled = new Array<boolean>(maxSeqCum);

      // working data
      interface IChkpRecord {
        [id: string]: typeCum;
      }
      const chkp = new Object() as IChkpRecord;
      enum ePatchState { waiting, ready, patched }
      // waiting: an xrst record waiting for a matching chkp
      // ready: starting value determined, ready to patch
      // patched: patch completed
      interface IPatchRecord {
        seq: number;
        id: string;
        state: ePatchState;
        value: typeCum;
      }
      const patches = new Array<IPatchRecord>();
      let sTotalCum = '';
      let iTotalSeq = -1; // location of total=display, can fix one only.
      // ptr into patch array next available entry

      // initialise the first patch request "MainStage"
      patches.push({
        seq: 0,
        id: 'MainStage',
        state: ePatchState.ready,
        value: initialCum
      });
      // push all xrst records
      for (let seqCum = 0; seqCum < maxSeqCum; seqCum++) {
        const curCum = arrCum[seqCum];
        const curXrst = curCum.getAttribute('xrst');
        if (curXrst && !fixSupp(curCum)) {
          trace(`xrst push patch waiting ${curXrst} seq ${seqCum}`);
          patches.push({
            seq: seqCum,
            id: curXrst,
            state: ePatchState.waiting,
            value: initialCum // will be overwritten by chkp
          });
        }
      }

      while (patches.some(p => p.state !== ePatchState.patched)) { // no longer checks npatches
        let cumRunning: typeCum; // running cum value
        let patchID: string; // non unique id of the current patch cycle
        const patch = patches.find(p => p.state === ePatchState.ready);
        if (patch) {
          cumRunning = patch.value.slice(0);
          patchID = patch.id;
          patch.state = ePatchState.patched; // we are patching this now
          trace('now patching', patch.id, dispCum(cumRunning), 'from seq ', patch.seq);
        } else {
          // no patch record is ready but some record is not yet patched,
          // so we have a dangling waiting state
          warn('error: unable to patch xrst');
          console.log(JSON.stringify(patches, null, 2));
          return;
        }

        for (let seqCum = patch.seq; seqCum < maxSeqCum; seqCum++) {
          const curCum = arrCum[seqCum];

          const curSupp = fixSupp(curCum);
          // first check xrst and patchend, both marks end of current patch
          const curXrst = curCum.getAttribute('xrst');
          if (curXrst) {
            // is this xrst applicable to current diff/ver?
            if (curSupp) {
              trace('xrst seq', seqCum, 'suppressed, id=', curXrst);
              // although supp, need to handle innerText if not nop
            } else {
              trace('xrst seq', seqCum, ' id=', curXrst, dispCum(cumRunning));
              if (patchID !== curXrst) {
                trace(`  current patch id=${patchID}, ending current stage.`);
                break; // nothing left to do in this stage
              }
            }
          }

          const curPatchEnd = curCum.getAttribute('patchend');
          if (curPatchEnd) {
            if (curPatchEnd === patchID) {
              if (curSupp) {
                trace('reach suppressed patch end', patchID, 'at seq', seqCum );
              } else {
                trace('reach patch end', patchID, 'at seq', seqCum);
                arrHandled[seqCum] = true;
                break; // end of current patch
              }
            } else {
              trace('reach irrelevant patch end', curPatchEnd, 'at seq', seqCum, 'my patch id is', patchID);
            }
          }

          const curChkp = curCum.getAttribute('chkp');
          if (curChkp) {
            if (curSupp) {
              trace('chkp seq', seqCum, 'suppressed, id=', curChkp);
              // although supp, need to handle innerText if not nop
            } else {
              chkp[curChkp] = cumRunning.slice(0);
              trace('chkp seq', seqCum, 'id=', curChkp, dispCum(chkp[curChkp]));
              patches.forEach(p => {
                if (p.id === curChkp) {
                  p.value = cumRunning.slice(0);
                  p.state = ePatchState.ready;
                  trace(`  patch xrst ${curChkp} at seq ${p.seq} to ${dispCum(p.value)}`);
                }
              });
            }
          }

          if (curCum.getAttribute('nop')) {
            trace('nop seq', seqCum, 'running', dispCum(cumRunning));
            arrHandled[seqCum] = true;
            continue;
          }

          if (arrHandled[seqCum]) {
            warn('seq handled twice: ', seqCum, curCum.outerHTML);
            break;
          }
          arrHandled[seqCum] = true;

          const curTotal = curCum.getAttribute('total');
          if (curTotal) {
            if (curTotal === 'display') {
              if (curSupp) {
                trace('total=display seq', seqCum, 'suppressed', formatCumTotal(cumRunning));
              } else {
                iTotalSeq = seqCum;
                if (sTotalCum === '') {
                  trace('display total from cum running', formatCumTotal(cumRunning));
                } else {
                  trace('display total from set', sTotalCum);
                }
                curCum.innerText = (sTotalCum === '') ? (sTotalCum = formatCumTotal(cumRunning)) : sTotalCum;
              }
            } else {
              // total=set
              if (curSupp) {
                trace('total=set seq', seqCum, 'suppressed', formatCumTotal(cumRunning));
              } else {
                sTotalCum = formatCumTotal(cumRunning);
                trace('setting seq', seqCum, formatCumTotal(cumRunning), sTotalCum);
                if (iTotalSeq > -1) {
                  arrCum[iTotalSeq].innerText = sTotalCum;
                  trace('set display total at iTotalSeq', iTotalSeq, 'to', sTotalCum);
                }
              }
            }
          } else {
            // handle normal case
            // falls here except nop= and total=
            fixCumEntry(curCum, cumRunning);
            // fixCumEntry updates cumRunning using info inside curCum
            trace('handling seq', seqCum, curCum.getAttribute('originalInnerText'), '->', curCum.innerText);
          }
        }
      }
      for (let seqCumScam = 0; seqCumScam < maxSeqCum; seqCumScam++) {
        if (!arrHandled[seqCumScam]) {
          warn(`some ${sCumClass} not handled`);
          for (let seqCum = 0; seqCum < maxSeqCum; seqCum++) {
            if (!arrHandled[seqCum]) {
              console.log(seqCum, arrCum[seqCum]);
            }
          }
          break;
        }
      }
    }

    // main body of fixAll()

    const sDiff = 'NHE'.substr(iDiff, 1);
    const sVer = iVer ? 'TG' : 'TDP'; // variable length

    fixCumAll(
      'loot'
      , 'spLoot'
      , [0, 0, 0]
      , fixLootEntry
      , fixLootFormat
    );

    fixCumAll(
      'pick'
      , 'spPick'
      , [0]
      , fixPickEntry
      , formatPickTotal
    );
  }

  function diffChange() {
    fixAll(seDiff.selectedIndex, seVer.selectedIndex);
  }

  $(() => {
    // all missions have spLoot and spPick
    // m14 is the only exception with none, but we are not added to m14.

    doTrace = (typeof thiefcu3Trace !== 'undefined');
    if (doTrace) {
      console.log('trace activated');
    }
    seDiff = document.getElementById('seDiff') as HTMLSelectElement;
    if (seDiff === null) {
      console.log('*** abort: seDiff not found');
      return;
    } else {
      $(seDiff).on('change', diffChange);
    }
    seVer = document.getElementById('seVer') as HTMLSelectElement;
    if (seVer === null) {
      console.log('*** abort: seVer not found');
      return;
    } else {
      $(seVer).on('change', diffChange);
    }
    suppAux = 0;
    if (typeof suppAux1Test === 'function') {
      const seAux1 = document.getElementById('seSuppAux1');
      if (seAux1 === null) {
        console.log('*** abort: seAux1 not found');
        return;
      }
      $(seAux1).on('change', diffChange);
      suppAux = 1;
      if (doTrace) console.log('suppAux1Test() detected');

      if (typeof suppAux2Test === 'function') {
        const seAux2 = document.getElementById('seSuppAux2');
        if (seAux2 === null) {
          console.log('*** abort: seAux2 not found');
          return;
        }
        $(seAux2).on('change', diffChange);
        suppAux = 2;
        if (doTrace) console.log('suppAux2Test() detected');
      }
    }

    diffChange();
  });

}) ();
